import { useState } from 'react';

import { ChevronDown, ChevronRight, ChevronUp, Plus, Trash } from 'lucide-react';
import { Button, Col } from 'twyne-new.ui';

import CustomFields from '../CustomFields';

export default function HasManyField({ config, extra, value: defaultValue = [], onChange }) {
  const [openned, setOpenned] = useState(true)
  const [value, setValue] = useState(defaultValue || [])

  const ToggleIcon = openned ? ChevronDown : ChevronRight

  const handleChange = value => {
    onChange({ value })
    setValue(value)
  }

  const handleAddGroup = idx => {
    typeof idx === 'number' ? value.splice(idx, 0, {}) : value.push({})
    handleChange([...value])
    setOpenned(true)
  }

  const handleDeleteGroup = idx => {
    handleChange(value.filter((_, i) => i !== idx))
  }

  const handleGroupChange = idx => (key, _value) => {
    value[idx][key] = _value
    handleChange([...value])
  }

  const handleOpenClose = () => {
    setOpenned(!openned)
  }

  const handleChangeIndex = (idx, i) => {
    const group = value[idx]
    let newIdx = idx + i

    if (newIdx < 0) {
      newIdx = 0
    } else if (newIdx >= value.length) {
      newIdx = value.length - 1
    }

    const newValue = [...value].filter((_, i) => i !== idx)
    newValue.splice(newIdx, 0, group)

    handleChange(newValue)
  }

  const type = Object.keys(config.items)[0]

  return (
    <div>
      <div className='flex items-center justify-between pr-1 cursor-pointer twy-text-base-accent'>
        <div onClick={handleOpenClose} className='flex items-center gap-1'>
          <ToggleIcon size={14} />
          <span className='text-lg'>{config.name}</span>
        </div>
        <Button size='sm' variant='light' color='accent' onClick={handleAddGroup}>
          Add
          <Plus size='14' />
        </Button>
      </div>
      {openned && value.map((c, idx) => {
        const key = c[type] && c[type].name || idx
        return (
          <div key={key}>
            <Col size='12' className="cursor-pointer transition-all h-4 mt-1 twy-subtle-neutral twy-subtle-neutral-hover rounded-xs" onClick={() => handleAddGroup(idx)} />
            <div className="flex border-2 twy-border-base mt-1">
              <div className="w-[10%] twy-subtle-neutral flex flex-col justify-around items-center">
                <div className="flex flex-col items-center">
                  <Button variant='ghost' size='sm' onClick={() => handleChangeIndex(idx, -1)}>
                    <ChevronUp size={16} />
                  </Button>
                  <Button variant='ghost' size='sm'>
                    {idx + 1}
                  </Button>
                  <Button variant='ghost' size='sm' onClick={() => handleChangeIndex(idx, 1)}>
                    <ChevronDown size={16} />
                  </Button>
                </div>
                <Button variant='ghost' size='sm' onClick={() => handleDeleteGroup(idx)}>
                  <Trash size={16} />
                </Button>
              </div>
              <div className='px-2 pt-2 w-full'>
                <CustomFields
                  config={config.items}
                  onChange={handleGroupChange(idx)}
                  custom={value[idx]}
                  extra={extra}
                />
              </div>
            </div>
          </div>
        )
      })}
      <Col size='12' className="cursor-pointer transition-all h-4 mt-1 twy-subtle-neutral twy-subtle-neutral-hover rounded-xs" onClick={handleAddGroup} />
    </div>
  )
}
